var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C8.55229 9.5 9 9.94771 9 10.5V19C9 19.5523 8.55229 20 8 20H1C0.447715 20 0 19.5523 0 19V10.5C0 9.94771 0.447715 9.5 1 9.5H8ZM19 12.5C19.5523 12.5 20 12.9477 20 13.5V19C20 19.5523 19.5523 20 19 20H12C11.4477 20 11 19.5523 11 19V13.5C11 12.9477 11.4477 12.5 12 12.5H19ZM2 18H7V11.5H2V18ZM13 18H18V14.5H13V18ZM19 0C19.5523 0 20 0.447715 20 1V9.5C20 10.0523 19.5523 10.5 19 10.5H12C11.4477 10.5 11 10.0523 11 9.5V1C11 0.447715 11.4477 0 12 0H19ZM13 8.5H18V2H13V8.5ZM8 0C8.55229 0 9 0.447715 9 1V6.5C9 7.05228 8.55229 7.5 8 7.5H1C0.447715 7.5 0 7.05228 0 6.5V1C0 0.447715 0.447715 0 1 0H8ZM2 5.5H7V2H2V5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.86c86c309fc39b11dceaf13e53853f6b.svg";
export { ForwardRef as ReactComponent };